const userEndpoints = {
  companyUsers: (companyId: string) => `/companies/${companyId}/users`
}

export default userEndpoints
